import * as React from "react";
import { connect } from "react-redux";
import { mapDispatchToProps } from "../../redux/actions";
import "../../css/ProjectModal.scss";
import { ProjectStatusFilterBy } from "../../interfaces/interfaces";
import { GetFreightStatesCheckPostalCode } from "../../api-calls/projectDataService";
// expected props
interface IProps {
  updateRedux: any;
  reduxModals: any;
  reduxProjectManagement: any;
  reduxAuth: any;
}
// local state
interface IState {
  projectName: string;
  consultingEngineer: string;
  contractor: string;
  city: string;
  state: string;
  jobStatus: string;
  freightStates:any[];
}

class ProjectModal extends React.Component<IProps, IState> {
  public state: IState = {
    projectName: "",
    consultingEngineer: "",
    contractor: "",
    city: "",
    state: "",
    jobStatus: ProjectStatusFilterBy[ProjectStatusFilterBy.Design],
    freightStates: []
  };

  //This is a specific modal for adding or editing a project.  Input is project name.
  async componentDidMount() {
    if (this.props.reduxModals.modalId === "edit-project" || this.props.reduxModals.modalId === "add-new-project") {
      if (this.props.reduxModals.modalId === "edit-project"){
        this.setState({
          projectName: this.props.reduxProjectManagement.selectedProject.projectName,
          consultingEngineer: this.props.reduxProjectManagement.selectedProject.consultingEngineer,
          contractor: this.props.reduxProjectManagement.selectedProject.contractor,
          city: this.props.reduxProjectManagement.selectedProject.city,
          state: this.props.reduxProjectManagement.selectedProject.state,
          jobStatus: this.props.reduxProjectManagement.selectedProject.jobStatus
        });
      }
      //Get all the state choices for the dropdown and check to see if the zip code in the user's profile is in New York city.
      let response = await GetFreightStatesCheckPostalCode(this.props.reduxAuth.postalCode);

      //response.states is a list of objects that contain a state (state abbrev) and a fullState property.
      this.setState({freightStates: response.states});

      let setToNewYorkCity: boolean = false;

      //Set profileState to user's logged in profile state.
      let profileState = this.props.reduxAuth.state;

      if (profileState && profileState.toLowerCase() === "ny"){
        profileState = "NY - State";
      }
      //If the profile state is the full state name, find it's match and assign profile state to it's abbreviation.
      let fullStateExistsInDropdownList = response.states.find((stateInfo:any) => stateInfo.fullState.toLowerCase() === profileState?.toLowerCase());
      if (fullStateExistsInDropdownList){
        profileState = fullStateExistsInDropdownList.state;
      }
      //Verify the profile state exists in list of abbreviated states.
      let stateExistsInDropdownList = response.states.find((stateInfo:any) => stateInfo.state.toLowerCase() === profileState?.toLowerCase());

      //Set state to "NY - City" if:
      //1. The profile postal code is in NY - City.
      //2. There hasn't been a state selected by the user yet. 
      if (response.isNewYorkState === true && !this.props.reduxProjectManagement.selectedProject?.state){
        this.setState({state: "NY - City"});
        setToNewYorkCity = true;
      }

      //Set state to a value other than "NY - City" if:
      //1. The user's profile State matches one of the states in the dropdown.
      //2. There hasn't been a state selected by the user yet (state is empty or null and not "Choose an Options").
      //3. The profile postal code is not in NY - City.
      else if (stateExistsInDropdownList && setToNewYorkCity === false && 
        (!this.props.reduxProjectManagement.selectedProject?.state)){
        console.log("Set profile state.");
        this.setState({state: profileState});
      }
      //Default to Alabama if nothing has been previously selected and user's postal code is not in NY - City 
      //and user's state is not in the list of states.
      else if (!this.props.reduxProjectManagement.selectedProject?.state){
        console.log("Set default Alabama.");
        this.setState({state: "AL"});
      }
      else {
        console.log("Set state to previously selected.");
        this.setState({state: this.props.reduxProjectManagement.selectedProject?.state})
      }
    }
  }

  validateAndSave(fieldName: any, newValue: any) {
    if (newValue.length <= 50) {
      this.setState({ [fieldName]: newValue } as Pick<IState, keyof IState>);
    }
  }

  public render() {
    const title = this.props.reduxModals.modalId === "edit-project" ? "Edit Job" : "New Job";
    const buttonText = this.props.reduxModals.modalId === "edit-project" ? "Save" : "Create";
    return (
      <div className="newProject">
        <div className="header">{title}</div>
        <div className="InputRow">
          <label className="proj-modal-label">Job Name</label>
          <input
            className="projectInput"
            type="text"
            placeholder="Job Name"
            value={this.state.projectName}
            onChange={(event) => this.validateAndSave("projectName", event.currentTarget.value)}
            autoFocus
          />
        </div>
        <div className="InputRow">
          <label className="proj-modal-label">Consulting Engineer</label>
          <input
            className="projectInput"
            type="text"
            placeholder="Consulting Engineer"
            value={this.state.consultingEngineer}
            onChange={(event) => this.validateAndSave("consultingEngineer", event.currentTarget.value)}
          />
        </div>
        <div className="InputRow">
          <label className="proj-modal-label">Contractor</label>
          <input
            className="projectInput"
            type="text"
            placeholder="Contractor"
            value={this.state.contractor}
            onChange={(event) => this.validateAndSave("contractor", event.currentTarget.value)}
          />
        </div>
        <div className="InputRow">
          <label className="proj-modal-label">City</label>
          <input
            className="projectInput"
            type="text"
            placeholder="City"
            value={this.state.city}
            onChange={(event) => this.validateAndSave("city", event.currentTarget.value)}
          />
        </div>
        <div className="InputRow">
          <div className="proj-modal-label">State</div>
          <div className="projectInputDropdown">
            <select className="" value={this.state.state} onChange={(event) => this.setState({ state: event.currentTarget.value })}>
              {this.getStateOptions()}
            </select>
          </div>
        </div>

        <div className="InputRow">
          <div className="proj-modal-label">Job Status</div>
          <div className="projectInputDropdown">
            <select className="" value={this.state.jobStatus} onChange={(event) => this.setState({ jobStatus: event.currentTarget.value })}>
              <option>{ProjectStatusFilterBy[ProjectStatusFilterBy.Design]}</option>
              <option>{ProjectStatusFilterBy[ProjectStatusFilterBy.Booking]}</option>
              <option>{ProjectStatusFilterBy[ProjectStatusFilterBy.Release]}</option>
            </select>
          </div>
        </div>

        <div className="button-container">
          <div className="proj-create-btn" onClick={() => this.userResponse("ok")}>
            {buttonText}
          </div>
          <div className="proj-cancel-btn" onClick={() => this.userResponse("cancel")}>
            Cancel
          </div>
        </div>
      </div>
    );
  }
  //This will trigger the componentDidUpdate method on ProjectManagement.tsx
  private userResponse(response: string) {
    this.props.updateRedux("UPDATE_MODALS", { showModal: false, userResponse: response });
    if (response === "ok" && this.state.projectName !== "") {
      this.props.updateRedux("UPDATE_PROJECT_MANAGEMENT", {
        projectName: this.state.projectName,
        consultingEngineer: this.state.consultingEngineer,
        contractor: this.state.contractor,
        city: this.state.city,
        state: this.state.state,
        jobStatus: this.state.jobStatus
      });
      if (this.props.reduxModals.modalId === "edit-project") {
        let selectedProject = this.props.reduxProjectManagement.selectedProject;
        selectedProject.projectName = this.state.projectName;
        selectedProject.consultingEngineer = this.state.consultingEngineer;
        selectedProject.contractor = this.state.contractor;
        selectedProject.city = this.state.city;
        selectedProject.state = this.state.state;
        selectedProject.jobStatus = this.state.jobStatus;
        
        this.props.updateRedux("UPDATE_PROJECT_MANAGEMENT", {selectedProject: selectedProject});
      }
    }
    if (response === "cancel") {
      this.props.updateRedux("UPDATE_PROJECT_MANAGEMENT", { projectName: "" });
    }
  }
  private getStateOptions(){
    const options = this.state.freightStates;
    
    if (options) {
      return options.map((item: any, index: number) => (
        <option key={index} value={item.state}>
          {item.state}
        </option>
      ));
    }
    return <option></option>;
  }
}

//------------------ Redux ----------------------------
function mapStateToProps(state: any) {
  return {
    reduxProjectManagement: state.reduxProjectManagement,
    reduxModals: state.reduxModals,
    reduxAuth: state.reduxAuth
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ProjectModal);
